<template>
  <div>
    <b-row>
      <b-col>
        <h5>{{ $t('message.dashboardContentContactPerson.message') }}</h5>
      </b-col>
    </b-row>
    <b-row
      v-for="i in Math.ceil(policyHolders.length / 2)"
      class="mt-3"
      :key="i">
      <b-col
        v-for="policyHolder in policyHolders.slice((i - 1) * 2, i * 2)"
        cols="12"
        xl="6"
        :key="policyHolder.id">
        <b-btn
          class="p-0 m-0 w-100"
          variant="transparent"
          router-tag="div"
          :to="'/policyHolders/' + policyHolder.id">
          <business-card
            class="rounded-0 h-100"
            :name="policyHolder.firstName + ' ' + policyHolder.lastName"
            :relation="$t('enums.relationTypes.' + policyHolder.relationshipType)"
            :email="policyHolder.email"
            :imageSrc="policyHolder.avatarUuid"
            :showIcon="!!policyHolder.dateOfDeath"
            :dateOfDeath="policyHolder.dateOfDeath">
            <div slot="bcFooter">
              <hr>
              <div class="d-flex flex-row">
                <b-badge class="p-2 mr-2">
                  {{ policyHolder.numberOfAssignedContracts }}
                </b-badge>
                <div>
                  {{ getNumberOfAssignedContractsText(policyHolder) }}
                </div>
              </div>
            </div>
          </business-card>
        </b-btn>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card
          class="rounded-0"
          :title="$t('message.dashboardContentContactPerson.insurance.title')">
          <p>
            {{ $t('message.dashboardContentContactPerson.insurance.message') }}
          </p>
          <b-form @submit.prevent="submit">
            <b-form-row>
              <b-col cols="6">
                <b-form-group
                  label-for="dateOfBirth"
                  :state="$v.regData.dateOfBirth.$error ? false : null"
                  :invalid-feedback="$t('error.dashboardContentContactPerson.dateOfBirth')">
                  <div slot="label">
                    <label>
                      {{ $t('message.dashboardContentContactPerson.insurance.label.dateOfBirth') }}
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <b-form-input
                    id="dateOfBirth"
                    class="rounded-0"
                    v-model="regData.dateOfBirth"
                    placeholder="TT.MM.JJJJ"
                    :state="$v.regData.dateOfBirth.$error ? false : null"
                    @change="$v.regData.dateOfBirth.$touch()">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="6">
                <b-form-group
                  label-for="contractNumber"
                  :state="$v.regData.contractNumber.$error ? false : null"
                  :invalid-feedback="$t('error.dashboardContentContactPerson.contractNumber')">
                  <div slot="label">
                    <label>
                      {{ $t('message.dashboardContentContactPerson.insurance.label.contractNumber') }}
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <b-form-input
                    id="contractNumber"
                    class="rounded-0"
                    v-model="regData.contractNumber"
                    :state="$v.regData.contractNumber.$error ? false : null"
                    @change="$v.regData.contractNumber.$touch()">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col class="text-right">
                <b-btn
                  class="rounded-0"
                  variant="primary"
                  type="submit">
                  {{ $t('message.dashboardContentContactPerson.insurance.btn.submit') }}
                </b-btn>
              </b-col>
            </b-form-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {required} from 'vuelidate/lib/validators'
  import BusinessCard from '@/components/common/BusinessCard'
  import utils from '@/utils'

  export default {
    name: 'DashboardContentContactPerson',
    components: {
      BusinessCard
    },
    computed: {
      policyHolders () {
        return this.$store.getters.policyHolders
      }
    },
    created () {
      this.$store.dispatch('fetchPolicyHolders')
    },
    data () {
      return {
        regData: {}
      }
    },
    methods: {
      getNumberOfAssignedContractsText (policyHolder) {
        if (policyHolder.numberOfAssignedContracts === 1) {
          return this.$t('message.dashboardContentContactPerson.numberOfAssignedContract')
        } else {
          return this.$t('message.dashboardContentContactPerson.numberOfAssignedContracts')
        }
      },
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          const payload = {
            dateOfBirth: this.$moment(this.regData.dateOfBirth, 'DD.MM.YYYY').format('YYYY-MM-DD'),
            contractNumber: this.regData.contractNumber
          }
          const successMsg = this.$t('message.dashboardContentContactPerson.addRolePolicyHolder') // Don't know why, but putting this.$t into message body will throw an exception, so this is a workaround
          const errorMsg = this.$t('error.dashboardContentContactPerson.addRolePolicyHolder')
          this.$store.dispatch('addRolePolicyHolder', payload)
            .then(() => {
              this.showSuccessMsg({message: successMsg})
            })
            .catch(() => {
              this.showErrorMsg({message: errorMsg})
            })
        }
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    },
    validations: {
      regData: {
        dateOfBirth: {
          required,
          isValidDate: utils.validators.isValidDate
        },
        contractNumber: {
          required,
          isValidContractNumber (value) {
            return utils.validators.isValidContractNumber(value, this)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardContentContactPerson.vue